<template>
  <base-button
    :class="{
      [$style.container] : true,
      ...computedClasses
    }"
    :style="getStyles"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </base-button>
</template>

<script>
import buttonMixin from 'lib/mixins/buttonMixin';
import BaseButton from 'atoms/base/BaseButton';

export default {
  name: 'SimpleButton',
  mixins: [
    buttonMixin,
  ],
  components: {
    BaseButton,
  },
};
</script>

<style lang="sass" module>
  @import '~sass/components/button'
</style>
